export default __webpack_public_path__ + "static/media/minus.f2605dcd.svg";